import { Feather } from 'lucide-react'
import { useGame } from '../state/store'
import { fmt, Decimal } from '../engine/decimal'
import { getThemeForEdition } from '../config/themes'

const ROMAN = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X']

export function Header() {
  const ink = useGame((s) => s.ink)
  const rate = useGame((s) => s.outputPerSec().toNumber())
  const edition = useGame((s) => s.edition)
  const type = useGame((s) => s.type)
  const theme = getThemeForEdition(edition)

  return (
    <header className="flex items-center justify-between border-b border-ink-border pt-6 pb-4">
      <div className="flex items-center gap-3">
        <Feather className="text-ink-teal" size={28} />
        <div>
          <h1 className="text-lg font-extrabold tracking-widest text-ink-teal">
            Incunabula
          </h1>
          <p className="text-[10px] uppercase tracking-[0.3em] text-ink-muted">
            Edition {ROMAN[edition] ?? edition} · {theme.name}
          </p>
        </div>
      </div>
      <div className="text-right">
        <div className="text-2xl font-extrabold text-ink-text tabular-nums">
          {fmt(ink)} <span className="text-sm text-ink-muted">Ink</span>
        </div>
        <div className="text-xs text-ink-teal tabular-nums">
          {fmt(new Decimal(rate))} / s
          {type > 0 && (
            <span className="ml-2 text-amber-400">{type} Type</span>
          )}
        </div>
      </div>
    </header>
  )
}
